import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nosidebar-layout',
  templateUrl: './nosidebar-layout.component.html',
  styleUrls: ['./nosidebar-layout.component.scss']
})
export class NosidebarLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
